import React from "react";
import Layout from "../../layouts/Layout";
import { connect } from "react-redux";
import actions from "../../redux/actions";
import { useNavigate } from "react-router-dom";
import BButton from "../../components/general/BButton";
import apiService from '../../utils/api.service';
import helper from "../../utils/helper";
import * as XLSX from "xlsx";
import _ from "lodash"

class RewardUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      refresh: true,
      excelData: []
    };
    this.createInputxlsx = this.createInputxlsx.bind(this);
    this.onUploadAPI = this.onUploadAPI.bind(this);
    this.reloadRefresh = this.reloadRefresh.bind(this);
  }

  createInputxlsx(e) {
    console.log('files[0] >>', e.target.files[0])
    const f = e.target.files[0]
    var name = f.name;
    console.log("name file >>", name);
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const wsname = wb.SheetNames[0]; // เลือกชีส แรก
      const ws = wb.Sheets[wsname];
      const tmp = XLSX.utils.sheet_to_csv(ws, { header: 1 });
      const data = this.csvToJSON(tmp);

      console.log("inputData>>>", data);
      this.setState({ excelData: data })
    };
    reader.readAsBinaryString(f);
    // console.log(this.fileinput);
  }

  csvToJSON(csv) {
    var lines = csv.split("\n");
    var result = [];
    var headers;
    headers = lines[0].split(",");

    for (var i = 1; i < lines.length; i++) {
      var obj = {};

      if (lines[i] == undefined || lines[i].trim() == "") {
        continue;
      }

      var words = lines[i].split(",");
      for (var j = 0; j < words.length; j++) {
        obj[headers[j].trim()] = words[j];
      }

      result.push(obj);
    }
    return result;
  }

  toPayload (excelData = []) {
    let payload = []
    for (const ed of excelData) {
      const [ firstName, lastName ] = `${ed['ชื่อ - นามสกุล พยาบาล']}`.split(' ')
      const upPoint = Number(ed['แต้มสะสมบุญ'])
      if (_.isNumber(upPoint)) {
        let type = upPoint >= 0 ? 6 : 7
        const obj = {
          firstName: firstName, 
          lastName: lastName,
          type: type, 
          point: Math.abs(upPoint)
        }
        payload.push(obj)
      }
    }
    return payload
  }

  reloadRefresh () {
    this.setState ({ refresh:false }, () => {
      setTimeout(() => this.setState ({ refresh: true }), 200)
    })
  }

  async onUploadAPI() {
    const excelData = this.state.excelData
    const payload = this.toPayload(excelData)
    console.log('payload >>', payload)
    try {
      this.setState({ loading: true });
      const header = {}
      const { resData } = await apiService.Iframe.CreateImportPoint(payload, header)
      this.setState({ loading: false });
      if (resData.resultCode === "20000") {
        alert('สำเร็จ')
        this.setState({ excelData: [] }, this.reloadRefresh)
      } else {
        alert('ไม่สำเร็จ' + resData.resultCode)
      }
      this.setState({ loading: false });
    }
    catch(e){
      console.log('API ERR', e)
      alert('มีบางอย่างผิดพลาด')
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <div>
        <BButton onClick={()=> {window.open(`${apiService.External.BaseFile}/api/excel-reward-template`,'_blank')} } setStyle="mini" disable={this.state.loading}>
          ดาวน์โหลด Template
        </BButton>
        <br/>
        <br/>
        { this.state.refresh ? ( <input id="" type="file" onChange={(e) => this.createInputxlsx(e)} /> ) : <div>Clear...</div>}
        <br/>
        <BButton onClick={this.onUploadAPI} setStyle="mini" disable={this.state.loading || this.state.excelData.length === 0}>
          อัพโหลดรีวอร์ด
        </BButton>
      </div>
    );
  }
}

function RewardUploadRoute(props) {
  let navigate = useNavigate();
  return <RewardUpload navigate={navigate} {...props} />;
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, actions)(RewardUploadRoute);
